export default __webpack_public_path__ + "static/wave-light-4-a5a9411c4cc614664c8dec96930fb4ab.png";